import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "backdrop", "sidebar" ]

  toggleSidebar() {
    this.sidebarTarget.classList.toggle('is-open')
    this.backdropTarget.classList.toggle('is-open')
  }
}